export async function subscribeToBrevo(email) {
  try {
    const response = await fetch('/api/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email })
    });

    if (!response.ok) {
      return { success: false, error: 'Failed to subscribe' };
    }

    return { success: true };
  } catch (error) {
    console.error('Error subscribing:', error);
    return { success: false, error: error.message };
  }
} 